import { debounce } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '../../TextField/component';

export class DebouncedInputField extends React.PureComponent {
  static propTypes = {
    label: PropTypes.string,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    onChange: PropTypes.func.isRequired,
  };

  static defaultProps = {
    label: '',
    value: '',
    placeholder: '',
  };

  state = {
    value: '',
  };

  componentDidMount() {
    this.mapStateFromProps(this.props);
  }

  mapStateFromProps = (props) => {
    const { value } = props;
    this.setState({ value });
  };

  updateValue = debounce(() => {
    const { value } = this.state;
    const { onChange } = this.props;
    onChange(value);
  }, 300);

  handleInputChange = (event) => {
    const value = event.target.value || '';
    this.setState({ value }, this.updateValue);
  };

  render() {
    const { value } = this.state;
    const { label, placeholder } = this.props;
    return (
      <TextField
        type="text"
        {...{ label, placeholder, value }}
        onChange={this.handleInputChange}
      />
    );
  }
}
